<template>
  <div class="bg-white w-full h-screen fixed inset-0 z-50">
    <div
      v-if="isLoading"
      class="flex items-center justify-center h-screen bg-white"
    >
      <div class="text-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F95031] mx-auto mb-2" />
        <p class="text-gray-500">
          Memuat Editor...
        </p>
      </div>
    </div>
    <iframe
      v-show="!isLoading"
      ref="v2iframe"
      frameborder="0"
      height="100%"
      width="100%"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
      @load="handleLoad"
    />
  </div>
</template>

<script>
export default {
  name: 'EmbedEditor',
  data() {
    return {
      isLoading: true,
    }
  },
  computed: {
    iframeSrc() {
      const id = this.$route.params.id || '1'
      return `${process.env.VUE_APP_BASE_AUTH_MODULE}/komstore/editor/${id}`
    },
  },
  methods: {
    handleLoad() {
      this.isLoading = false
    },
  },
}
</script>

<style scoped>
/* Reset any margin/padding that might affect the iframe */
div, iframe {
  margin: 0;
  padding: 0;
  display: block;
}
</style>
